module.exports = {"login":{"main_header":"Hello There","login_text":"LOGIN","email_text":"Email","password_text":"PASSWORD","keep_me_signin":"Keep Me Signed in"}}


//////////////////
// WEBPACK FOOTER
// ./lang/en/auth.json
// module id = YsB1
// module chunks = 5